import { combineReducers } from 'redux';

export default combineReducers({
    isAuthenticated: (state = {}) => state,
    publicId: (state = 0) => state,
    canCreateEvents: (state = false) => state,
});
